import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DWPValidatorsService} from '../../dwpvalidators.service';
import {DeclineSpecialRequestRequest} from '../decline-special-request-request.model';
import {WarrantyService} from '../../warranty/warranty.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SweetUtil} from '../../components/commons/sweet/sweet-util-service';

@Component({
  selector: 'app-decline',
  templateUrl: './decline.component.html',
  styleUrls: ['./decline.component.css']
})
export class DeclineComponent implements OnInit {
  @Input()
  declineSpecialRequestRequest: DeclineSpecialRequestRequest;
  form: UntypedFormGroup;


  constructor(private formBuilder: UntypedFormBuilder, validators: DWPValidatorsService, private warrantyService: WarrantyService,
              private activeModal: NgbActiveModal, private sweetUtil: SweetUtil) {
    this.form = formBuilder.group({
      declineReason: new UntypedFormControl('', [validators.notBlank, Validators.maxLength(500)])
    });
  }

  ngOnInit(): void {
  }

  invalid(): boolean {
    return !this.form.valid && this.form.get('declineReason').dirty;
  }

  declineSpecialRequest(): void {
    this.declineSpecialRequestRequest.declineReason = this.form.get('declineReason').value;
    this.warrantyService.declineSpecialRequest(this.declineSpecialRequestRequest).subscribe((result: number) => {
      this.activeModal.close(result);
    }, () => {
      this.sweetUtil.showError('Declining Special Request Failed.');
    });
  }
}
